import * as wasmBindgen from "../wasm/sr";
/**
 * Singlethreaded release build MmdWasmInstanceType
 *
 * Requirements for use:
 *
 * - Browser that supports WebAssembly
 */
export class MmdWasmInstanceTypeSR {
    getWasmInstanceInner() {
        return wasmBindgen;
    }
}
